import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { Swiper } from "scmp-app/components/swiper";

export const StyledMenuItem = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  white-space: nowrap;
`;

export const StyledMenuBar = styled.div`
  scrollbar-width: none;

  display: flex;
  align-items: center;

  overflow-x: scroll;

  touch-action: pan-x;

  ${StyledMenuItem} + ${StyledMenuItem} {
    margin-inline-start: 16px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  position: relative;

  margin: 0;
  padding: 0;

  overflow-y: hidden;

  .swiper-wrapper {
    block-size: 24px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    display: flex;
    align-items: center;

    inline-size: auto;

    white-space: nowrap;

    &:not(:last-child) {
      margin-inline-end: 16px;
    }
  }
`;
